import FormSubProgramFIeld from './FormSubProgramFIeld'

export default function FormLeadDetails({
    formValues,
    handleChange,
    handleNext,
    handleBookClass,
    requestingClass,
    page1
}) {
        const countryCodes = [
            { label: '🇺🇸 +1', value: '+1' },
            { label: '🇨🇦 +1', value: '+1' },
            { label: '🇦🇪 +971', value: '+971' },
            { label: '🇬🇧 +44', value: '+44' },
            { label: '🇦🇺 +61', value: '+61' },
            { label: '🇮🇳 +91', value: '+91' },
            { label: '🇲🇾 +60', value: '+60' },
            { label: '🇸🇦 +966', value: '+966' },
            { label: '🇶🇦 +974', value: '+974' },
            { label: '🇰🇼 +965', value: '+965' },
            { label: '🇴🇲 +968', value: '+968' },
            { label: '🇧🇭 +973', value: '+973' }
        ]

        return (
            <>
                <div className="input_field">
                    <input
                        className="font-Quick font-med"
                        name="name"
                        value={formValues.name}
                        onChange={handleChange}
                        type="text"
                        placeholder="Full Name"
                    />
                </div>
                <div className="input_field">
                    <input
                        className="font-Quick font-med"
                        name="email"
                        value={formValues.email}
                        onChange={handleChange}
                        type="email"
                        placeholder="Email ID"
                    />
                </div>
                <div className="phone_number">
                    <div className="input_field country_code">
                        <select
                            className="font-Quick font-med"
                            name="countryCode"
                            onChange={handleChange}
                        >
                            <option value="">Country Code</option>
                            {countryCodes.map((item, key) => (
                                    <option value={item.value} key={`${item.value}-${key}`}>
                                        {item.label}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className="input_field">
                        <input
                            className="font-Quick font-med"
                            name="phoneNumber"
                            onChange={handleChange}
                            type="number"
                            placeholder="Mobile Number"
                        />
                    </div>
                </div>

                <div className="input_field">
                    <select
                        className="font-Quick font-med"
                        name="syllabus"
                        onChange={handleChange}
                    >
                        <option value="">Select Syllabus</option>
                        {[`CBSE`, `STATE`, `ICSE`, `IGCSE`,'Other'].map(
                            (item, key) => (
                                <option value={item} key={key}>
                                    {item}
                                </option>
                            )
                        )}
                    </select>
                </div>

                <div className="input_field">
                    <input
                        className="font-Quick font-med"
                        name="grade"
                        onChange={handleChange}
                        type="number"
                        placeholder="Class"
                    />
                </div>

                <div className="input_field">
                    <input
                        className="font-Quick font-med"
                        name="subjects"
                        onChange={handleChange}
                        type="text"
                        placeholder="Subject"
                    />
                </div>

                <div
                    className="font-Quick font-bold button_form"
                    onClick={!requestingClass ? handleBookClass : () => {}}
                >
                    Book A Free Class
                </div>
            </>
        )
    } 
